import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PostSanctionedDocsEdit from "./PostSanctionedDocsEdit";
import FlexCard from "../../LoanApplications/Helpers/FlexCard";

const PostSanctionedDocs = (props) => {
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  var isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  var tabStatus = props.urlparams.params.status;
  const productTypeParam = props.urlparams.params.producttype;
  var applStatus = props.urlparams.params.applicationStatus;
  const [sanctioneddocs, setSanctioneddocs] = useState([]);
  const [editdata, setEditdata] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState("permanent_address");
  // ----------------------------------------------------------------
  const [uwdecision, setUwdecision] = useState("");
  const [queries, setQueries] = useState([{ query: "" }]);
  const [editmode, setEditmode] = useState(false);
  const [bankDataAsPerBSA, setBankDataAsPerBSA] = useState({});
  const [summaryScoreData, setSummaryScoreData] = useState(null);
  // ----------------------------------------------------------------

  // Add Queries
  const addQueries = () => {
    setQueries((prevState) => [...prevState, { query: "" }]);
  };

  const handleUWDecision = (val) => {
    let value = val[0].key;
    setUwdecision(value);
    setQueries([{ query: "" }]);
  };

  const handleDecision = (e, data) => {
    // console.log("formData", data);

    const resolve = (title) => {
      navigate(
        `/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`
      );
      swal2.fire({
        title: `Post Sanction ${title} Successfully`,
        icon: "success",
        iconColor: "#DE3232",
        confirmButtonColor: "#DE3232",
        confirmButtonText: "Close",
        timer: 3000,
      });
    };

    if (data?.uwDecision === _enum.UNDER_WRITER_DECISION_MAP["approved"]) {
      props?.apis
        ?.apiUnderWriterApprovePostSanctionApplication({
          applicationId: props.urlparams.params.id,
        })
        .then(() => resolve("Approved"));
    }
    if (data?.uwDecision === _enum.UNDER_WRITER_DECISION_MAP["declined"]) {
      swal2
        .fire({
          title:
            "Are you sure you want to reject the application?\n Please provide your remarks",
          icon: "info",
          iconColor: "#DE3232",
          input: "text",
          showCancelButton: true,
          confirmButtonColor: "#DE3232",
          cancelButtonColor: "##D6DBE7",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let payload = {
              rejectedReason: result.value,
            };
            props.apis
              .apiUnderWriterRejectApplication(payload, {
                applicationId: props.urlparams.params.id,
              })
              .then(() => resolve("Declined"))
              .catch((err) => {
                console.log(err);
              });
          }
        });
    }
  };

  const getApplicationDetails = () => {
    props.apis
      .apiGetUnderWriterApplicationDetails({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        if (res) {
          let addressObj;
          let communicationAddressObj = res?.ApplicationAddressInfo.filter(
            (v) => v.addressType === "COMMUNICATION"
          );
          let permanentAddressObj = res?.ApplicationAddressInfo.filter(
            (v) => v.addressType === "PERMANENT"
          );
          if (permanentAddressObj.length > 0) {
            addressObj = permanentAddressObj;
          } else if (
            permanentAddressObj.length === 0 &&
            communicationAddressObj.length > 0
          ) {
            addressObj = communicationAddressObj;
          }

          console.log({ addressObj });
          let addr1 = addressObj[0]?.address1?.toTitleCase();
          let addr2 = addressObj[0]?.address2?.toTitleCase();
          let addr3 = addressObj[0]?.address3?.toTitleCase();
          let address = `${addr1 ? addr1 + "," : ""} ${
            addr2 ? addr2 + "," : ""
          } ${addr3 ? addr3 + "," : ""}`;

          setSanctioneddocs({
            permanent_address: {
              residence_status: addressObj[0]?.residenceStatus,
              pin_code: addressObj[0]?.pincode,
              city: addressObj[0]?.city,
              address_1: address,
              state: addressObj[0]?.state,
              document_proof: _enum.DOC_TYPES_MAP[addressObj[0]?.docType],
            },
            reference_details_1: {
              name: res?.reference1name,
              mobile_no: res?.reference1mobile,
              relation: res?.reference1relation,
              colspan_key: "col-12 col-md-4",
              colspan_value: "col-12 col-md-4",
            },
            reference_details_2: {
              name: res?.reference2name,
              mobile_no: res?.reference2mobile,
              relation: res?.reference2relation,
              colspan_key: "col-12 col-md-4",
              colspan_value: "col-12 col-md-4",
            },
            bank_account_details: {
              account_holder_name: res?.accountHolderName,
              account_no: res?.accountNumber,
              bank_name: res?.accountHolderBankName?.toTitleCase(),
              IFSC_code: res?.accountHolderBankIFSC,
            },
            additionalDocsSubmitted: res?.additionalDocsSubmitted?.filter(
              (v) => v.category === "FINAL_REVIEW"
            ),
            tvr_comment: res?.customerTVRComment,
          });
          setEditdata({
            permanent_address:
              res?.ApplicationAddressInfo[1] || res?.ApplicationAddressInfo[0],
            reference_details_1: {
              reference1name: res?.reference1name,
              reference1mobile: res?.reference1mobile,
              reference1relation: res?.reference1relation,
            },
            reference_details_2: {
              reference2name: res?.reference2name,
              reference2mobile: res?.reference2mobile,
              reference2relation: res?.reference2relation,
            },
            bank_account_details: {
              accountHolderName: res?.accountHolderName,
              accountNumber: res?.accountNumber,
              accountHolderBankName: res?.accountHolderBankName,
              accountHolderBankIFSC: res?.accountHolderBankIFSC,
            },
            additionalDocsSubmitted: res?.additionalDocsSubmitted?.filter(
              (v) => v.category === "FINAL_REVIEW"
            ),
          });
        }
      });
  };

  const getBankDataAsPerBSA = () => {
    // props.apis
    //   .apiUnderWriterGetBsaReport({
    //     applicationNumber: props.urlparams.params.id,
    //     // isDownload: false,
    //   })
    //   .then((res) => {
    //     console.log({ res });
    //     let result = Object.fromEntries(
    //       Object.entries(res?.result?.json).filter(([key, value]) =>
    //         key.startsWith("Summary")
    //       )
    //     );
    //     let data = result["Summary - Scorecard"].reduce((acc, curr) => {
    //       acc[curr.Item] = curr.Details;
    //       return acc;
    //     }, {});
    //     setBankDataAsPerBSA(
    //       Object.only(data, [
    //         "Customer Name",
    //         "Account Number",
    //         "Bank",
    //         "IFSC Code",
    //       ])
    //     );
    //   })
    //   .catch((err) => {});

    props.apis
      .apiUnderWriterVerifyBsaStatus({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        if (res?.report?.reportStatus === "ANALYSED") {
          let accountData = Object.only(res?.reportAccounts?.[0]?.account, [
            "accountName",
            "accountNumber",
            "bankName",
            "ifscCode",
            "accountTypeName",
            "startDate",
            "endDate",
          ]);
          setSummaryScoreData({
            ...accountData,
            bankScore: res.report.bankScore,
          });
        } else if (res?.status === "ANALYSIS ON HOLD") {
          swal2.fire({
            title: "BSA Analysis On-Hold! \n Please check with team",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 2000,
          });
        } else if (res?.status === "IN PROGRESS") {
          swal2.fire({
            title: "BSA generation In-progress! \n Please check in sometime",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 2000,
          });
        } else if (res?.status === "pending") {
          // generateReport();
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          // generateReport();
        }
      });
  };

  useEffect(() => {
    getApplicationDetails();
  }, [editmode]);

  useEffect(() => {
    getBankDataAsPerBSA();
  }, []);

  // ----------------------------------------------------------------
  const openEditView = (e, name) => {
    console.log({ name });
    setEditmode(true);
    setActiveAccordion(name);
  };
  const closeEditView = (e) => {
    setEditmode(false);
  };
  // ----------------------------------------------------------------
  props.$setNode({
    props,
    sanctioneddocs,
  });
  return (
    <>
      {editmode === false ? (
        <>
          <div className="card p-4">
            <FlexCard
              title="Permanent Address"
              data={sanctioneddocs && sanctioneddocs?.permanent_address}
              {...(!isAdmin
                ? {
                    editable: isReadonly ? false : true,
                  }
                : {})}
              // editable={isReadonly ? false : true}
              onEdit={(...args) => openEditView(...args, "permanent_address")}
            />
          </div>
          <div className="card p-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-5">
                <FlexCard
                  title="Reference Details - 1"
                  data={
                    sanctioneddocs
                      ? {
                          ...Object.except(
                            sanctioneddocs?.reference_details_1,
                            ["colspan_key", "colspan_value"]
                          ),
                        }
                      : null
                  }
                  colspan_key={
                    sanctioneddocs &&
                    sanctioneddocs?.reference_details_1?.colspan_key
                  }
                  colspan_value={
                    sanctioneddocs &&
                    sanctioneddocs?.reference_details_1?.colspan_value
                  }
                />
              </div>
              <div className="col-12 col-md-2 col-lg-2 d-flex align-item-center justify-content-center">
                <div className="v_line"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-5">
                <FlexCard
                  title="Reference Details - 2"
                  data={
                    sanctioneddocs
                      ? {
                          ...Object.except(
                            sanctioneddocs?.reference_details_2,
                            ["colspan_key", "colspan_value"]
                          ),
                        }
                      : null
                  }
                  colspan_key={
                    sanctioneddocs &&
                    sanctioneddocs?.reference_details_2?.colspan_key
                  }
                  colspan_value={
                    sanctioneddocs &&
                    sanctioneddocs?.reference_details_2?.colspan_value
                  }
                  {...(!isAdmin
                    ? {
                        editable: isReadonly ? false : true,
                      }
                    : {})}
                  onEdit={(...args) =>
                    openEditView(...args, "reference_details")
                  }
                />
              </div>
            </div>
          </div>
          <div className="card p-4">
            <FlexCard
              title="Bank Account Details"
              data={sanctioneddocs && sanctioneddocs?.bank_account_details}
              {...(!isAdmin
                ? {
                    editable: isReadonly ? false : true,
                  }
                : {})}
              onEdit={(...args) =>
                openEditView(...args, "bank_account_details")
              }
            />
          </div>
          <div className="card p-4">
            <FlexCard
              title="Bank Account Details As per BSA"
              data={summaryScoreData}
            />
          </div>
          <div className="card profile_card additional_docs mx-0">
            <div className="card-header p-0 border-0">
              <div className="d-flex align-items-center mb-3">
                <h4 className="theme_text_sm ms-2 mb-0">Additional Document</h4>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="docs_card_container row g-0">
                {sanctioneddocs &&
                sanctioneddocs?.additionalDocsSubmitted?.length > 0
                  ? sanctioneddocs?.additionalDocsSubmitted?.map((doc) => {
                      return (
                        <div className="col-6 col-sm-4 col-md-6 col-lg-3">
                          <div className="docs_card d-flex align-items-center justify-content-evenly">
                            <img
                              src={imagepaths.docsCardRedIcon}
                              alt="docsCardRedIcon"
                            />
                            <div>
                              {doc?.docType?.toUpperCase() === "OTHERS" ? (
                                <h2 className="title">{doc?.fileName}</h2>
                              ) : (
                                <h2 className="title">{doc?.docType}</h2>
                              )}
                              {sanctioneddocs &&
                              sanctioneddocs?.additionalDocsSubmitted?.length >
                                0 ? (
                                <a
                                  href={`${BASE_URL}${doc?.fileId}`}
                                  className="text-primary"
                                >
                                  Download
                                </a>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>

          <div className="card profile_card tvr_comment mx-0">
            <div className="card-header p-0 border-0">
              <div className="d-flex align-items-center mb-3">
                <h4 className="theme_text_sm ms-2 mb-0">TVR Comment</h4>
              </div>
            </div>
            <div className="card-body p-0 ms-2">
              <p className="comment_heading">Comment</p>
              <p className="comment">
                {(sanctioneddocs && sanctioneddocs?.tvr_comment) || "-"}
              </p>
            </div>
          </div>

          {isReadonly ? (
            <>
              <div className="nav_container mt-5">
                {tabStatus === "sanctioned" ||
                tabStatus === "closed" ||
                tabStatus === "pending" ? (
                  <button
                    type="button"
                    onClick={(...args) => props.changeTab(...args, "queries")}
                    className="btn btn-primary-lite me-3"
                  >
                    Back
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={(...args) =>
                      props.changeTab(...args, "finalreview")
                    }
                    className="btn btn-primary-lite me-3"
                  >
                    Back
                  </button>
                )}
                {tabStatus === "pending" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(...args) =>
                      props.changeTab(...args, "predisburse")
                    }
                  >
                    Next
                  </button>
                ) : (
                  <Link
                    to={`/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`}
                    className="btn btn-primary"
                  >
                    Close
                  </Link>
                )}
              </div>
            </>
          ) : !isReadonly && applStatus === "SANCTIONED" ? (
            <>
              <div className="nav_container mt-5">
                {tabStatus === "sanctioned" ? (
                  <button
                    type="button"
                    onClick={(...args) => props.changeTab(...args, "queries")}
                    className="btn btn-primary-lite me-3"
                  >
                    Back
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={(...args) =>
                      props.changeTab(...args, "finalreview")
                    }
                    className="btn btn-primary-lite me-3"
                  >
                    Back
                  </button>
                )}
                {tabStatus === "pending" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(...args) =>
                      props.changeTab(...args, "predisburse")
                    }
                  >
                    Next
                  </button>
                ) : (
                  <Link
                    to={`/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`}
                    className="btn btn-primary"
                  >
                    Close
                  </Link>
                )}
              </div>
            </>
          ) : (
            <AppForm
              className={Object.className({
                "mx-auto": true,
              })}
              onSubmit={handleDecision}
            >
              <div
                className={Object.className({
                  "px-0": true,
                  "d-none": applStatus === "SANCTIONED",
                })}
              >
                {/* <AppInput
                  name="uwDecision"
                  label="Underwriter Decision"
                  type="select"
                  options={_enum.UNDER_WRITER_DECISIONS.filter(
                    (v) => v.key !== "DISCREPANCY"
                  )}
                  onChange={(...args) => handleUWDecision(...args)}
                  outerclass="col-12 col-md-3"
                  required="true"
                ></AppInput> */}

                <div
                  className={Object.className({
                    "card mt-3 h-auto": true,
                  })}
                >
                  {uwdecision && uwdecision === "DISCREPANCY" ? (
                    <>
                      <div className="row p-3">
                        {queries &&
                          queries.map((query, i) => {
                            return (
                              <div className="col-12 col-md-4">
                                <AppInput
                                  name={`queries.${i}.query`}
                                  label={`Query`}
                                  type="textarea"
                                ></AppInput>
                              </div>
                            );
                          })}
                      </div>
                      <div className="p-3">
                        <button
                          type="button"
                          className="btn btn-primary-transparent py-0"
                          onClick={(...args) => addQueries(...args)}
                        >
                          + Add More
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="row p-3 d-none">
                      <AppInput
                        name="messageText"
                        label="Remarks"
                        type="textarea"
                        outerclass="col-12 col-md-9 mb-3"
                      ></AppInput>
                    </div>
                  )}
                </div>
              </div>

              {/* <div
                className={Object.className({
                  "nav_container mt-5": true,
                  "d-none": isAdmin,
                })}
              >
                <Link
                  to={`/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`}
                  className="btn btn-primary-lite me-3"
                >
                  Cancel
                </Link>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div> */}
            </AppForm>
          )}
        </>
      ) : (
        <PostSanctionedDocsEdit
          closeEditView={(...args) => closeEditView(...args)}
          editdata={editdata}
          activeAccordion={activeAccordion}
        />
      )}
    </>
  );
};

export default constore(PostSanctionedDocs);
